import { computed, inject, Injectable } from '@angular/core';
import { OrderSelectedCustomization } from '../../../../../../models/order/api-models/order-pd-response.model';
import { OrderStateServiceV2 } from '../../order-state.service';
import { OrderFlowType } from '../../../../../../models/order/order.model';
import { VoiceProductResponseService } from '../../order-api-response/voice-pd-response.service';
import { OrderCustomizationSubPayload } from '../../../../../../models/order/workflow/order-customization.model';

@Injectable({ providedIn: 'root' })
export class OrderVoiceCustomizationsStateService {
    private orderStateService = inject(OrderStateServiceV2);
    private voicePdResponseService = inject(VoiceProductResponseService);

    selectedCustomizations = computed<OrderSelectedCustomization[]>(() => {
        const order = this.orderStateService.order();
        const voicePdResponse = this.voicePdResponseService.productResponse();
        if (!order || !voicePdResponse) return [];

        const selectedOffers = order.voiceFlow?.voiceOffers?.offers || [];
        if (!selectedOffers.length) return [];

        const result: OrderSelectedCustomization[] = [];
        for (const offer of selectedOffers) {
            const byCode = offer.customizationCode
                ? this.voicePdResponseService.findByCustomizationCode(offer.customizationCode)
                : undefined;
            const customization = byCode?.customization.Choices?.Choice?.some(c => c.ChoiceCode === offer.choiceCode)
                ? byCode
                : this.voicePdResponseService.findCustomizationByChoiceCode(offer.choiceCode);
            if (!customization) continue;

            const choice = customization.customization.Choices?.Choice
                .find(c => c.ChoiceCode === offer.choiceCode);
            result.push({
                type: OrderFlowType.Voice,
                choice,
                customizationReference: customization,
                customization: customization.customization
            });
        }
        result.sort((a, b) => (a.choice?.CartSeq || 0) - (b.choice?.CartSeq || 0));
        return result;
    });

    buildCustomizationPayload(): OrderCustomizationSubPayload[] | null {
        const voiceComponent = this.voicePdResponseService.getProductComponent();
        if (!voiceComponent) return null;

        const customizations: OrderCustomizationSubPayload[] = [];
        const selected = this.selectedCustomizations();

        voiceComponent.Customizations?.Customization.forEach(cust => {
            cust.Choices?.Choice?.forEach(choice => {
                const rootPayload: OrderCustomizationSubPayload = {
                    Choice: choice.ChoiceCode || '',
                    Code: cust.CustomizationCode || '',
                    Customizations: [],
                    Usoc: choice.Usoc || ''
                };

                choice.Customizations?.Customization?.forEach(nestedCust => {
                    nestedCust.Choices?.Choice?.forEach(nestedChoice => {
                        const isSelected = selected.find(selCust => selCust.choice?.ChoiceCode === nestedChoice.ChoiceCode);
                        if (isSelected) {
                            rootPayload.Customizations.push({
                                Choice: isSelected.choice?.ChoiceCode || '',
                                Code: isSelected.customization?.CustomizationCode || '',
                                Usoc: isSelected.choice?.Usoc || ''
                            });
                        }
                    });
                });

                customizations.push(rootPayload);
            });
        });

        return customizations.length > 0 ? customizations : null;
    }
}
